<img [src]="logoSrc" alt="hycite logo" class="logo-hy-cite" />
